// src/telas/editar-tecnico/contato/index.tsx

import { RxDotFilled } from "react-icons/rx";
import styles from "../styles.module.css";
import { useContext } from "react";
import { FormularioContext } from "..";
import {
  capitalizarPrimeiraLetraMaiusculaDeCadaPalavra,
  formatarTelefone,
  validarEmail,
} from "../../../formatting/formatting";
import Swal from "sweetalert2";

export function Contato() {
  const context = useContext(FormularioContext);

  function atualizarFormulario(event: React.ChangeEvent<HTMLInputElement>) {
    let nome = event.target.name;
    let value = `${event.target.value}`;

    context?.setFormulario({ ...context.formulario, ...{ [nome]: value } });
  }

  function verificaEmail(event: React.ChangeEvent<HTMLInputElement>) {
    const email = event.target.value;
    const { valido, mensagem } = validarEmail(email);

    if (!valido) {
      context?.setFormulario({ ...context.formulario, A2_EMAIL: "" });
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: mensagem,
      });
    }
  }

  return (
    <div className={styles.groupCardForm}>
      {/* CONTATO — apenas PJ */}
      {context?.formulario.A2_TIPO === "J" && (
        <div className={styles.groupInput}>
          <span>
            Contato <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            onChange={atualizarFormulario}
            value={capitalizarPrimeiraLetraMaiusculaDeCadaPalavra(
              context?.formulario.A2_CONTATO || "",
            )}
            name="A2_CONTATO"
            type="text"
            placeholder="Nome do Contato"
            style={{ width: "100%" }}
          />
        </div>
      )}

      {/* TELEFONE */}
      <div className={styles.formGroup}>
        <div className={styles.groupInput}>
          <span>
            Telefone <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            onChange={atualizarFormulario}
            value={formatarTelefone(context?.formulario.A2_TEL || "")}
            name="A2_TEL"
            type="text"
            placeholder="(00) 00000-0000"
            maxLength={14}
          />
          <label>Digite apenas números</label>
        </div>
      </div>

      {/* E-MAIL */}
      <div className={styles.groupInput}>
        <span>
          E-mail <RxDotFilled size={16} className={styles.legend} />
        </span>
        <input
          onChange={atualizarFormulario}
          onBlur={verificaEmail}
          value={context?.formulario.A2_EMAIL}
          name="A2_EMAIL"
          type="email"
          placeholder="teste@teste.com"
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );
}